import React from 'react';
import {CSSTransition, Transition, TransitionGroup} from "react-transition-group";
import trees from '../../images/dschungel/trees.png'

import uuid from 'uuid'



function Trees(props) {

    const renderSheep = () => {
        if (props.show) {
            return  (

                <div>
                    <img src={trees} style={sheep}/>
                </div>


            )
        }
    }

    return(
        <TransitionGroup>
            <CSSTransition
                key={uuid()}
                timeout={600}
                classNames='fade'>
                {renderSheep}
            </CSSTransition>
        </TransitionGroup>

    )

}


export default Trees



const sheep = {
    position: 'fixed',
    zIndex: -1,
    maxHeight: '90%',
    maxWidth:'100%',
    left:'0',
    right:'0',
    top:'0',
    bottom:'0',
    margin:'auto'
}

